import { render, staticRenderFns } from "./DetailWithdrawal.vue?vue&type=template&id=2c57d06c&scoped=true"
import script from "./DetailWithdrawal.vue?vue&type=script&lang=js"
export * from "./DetailWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./DetailWithdrawal.vue?vue&type=style&index=0&id=2c57d06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57d06c",
  null
  
)

export default component.exports